(() => {
  const init = () => {
    if (!document.body.classList.contains('template-policy')) return;
    const container = document.querySelector('.shopify-policy__container');
    const title = container?.querySelector('.shopify-policy__title');
    const body = container?.querySelector('.shopify-policy__body');
    if (!container || !title || !body || container.dataset.policyEnhanced === 'true') return;
    container.dataset.policyEnhanced = 'true';

    const lede = document.createElement('p');
    lede.className = 'policy-page__lede';
    lede.textContent = 'Clear information about shopping with Muaazon, including your rights, our responsibilities, and how to contact us when you need help.';
    title.appendChild(lede);

    const layout = document.createElement('div');
    layout.className = 'policy-page__layout';
    const aside = document.createElement('aside');
    aside.className = 'policy-page__aside';
    aside.setAttribute('aria-label', 'Policy navigation and support');

    const policyNav = document.createElement('nav');
    policyNav.className = 'policy-page__toc';
    policyNav.setAttribute('aria-label', 'Store policies');
    const policyNavTitle = document.createElement('p');
    policyNavTitle.className = 'policy-page__aside-title';
    policyNavTitle.textContent = 'Policies';
    const policyList = document.createElement('ol');
    policyList.className = 'policy-page__toc-list';
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const knownPolicies = [
      { href: '/policies/shipping-policy', label: 'Shipping' },
      { href: '/policies/refund-policy', label: 'Return' },
      { href: '/policies/privacy-policy', label: 'Privacy' },
      { href: '/policies/terms-of-service', label: 'Terms' },
      { href: '/pages/contact', label: 'Contact' },
    ];
    knownPolicies.forEach((item) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = item.href;
      a.textContent = item.label;
      if (currentPath === item.href.replace(/\/$/, '') || currentPath.endsWith(item.href)) {
        a.setAttribute('aria-current', 'page');
        a.classList.add('is-active');
      }
      li.appendChild(a);
      policyList.appendChild(li);
    });
    policyNav.append(policyNavTitle, policyList);
    aside.appendChild(policyNav);

    const headings = Array.from(body.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (headings.length >= 2) {
      const nav = document.createElement('nav');
      nav.className = 'policy-page__toc';
      nav.setAttribute('aria-label', 'On this page');
      const navTitle = document.createElement('p');
      navTitle.className = 'policy-page__aside-title';
      navTitle.textContent = 'On this page';
      const list = document.createElement('ol');
      list.className = 'policy-page__toc-list';
      const used = new Set();
      headings.forEach((heading, index) => {
        const base = (heading.textContent.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-') || `policy-section-${index + 1}`).replace(/^-|-$/g, '');
        let id = base;
        let suffix = 2;
        while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = `${base}-${suffix++}`;
        used.add(id);
        heading.id = id;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });
      nav.append(navTitle, list);
      aside.appendChild(nav);
    }

    const support = document.createElement('div');
    support.className = 'policy-page__support-card';
    support.innerHTML = '<span class="policy-page__support-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" focusable="false"><path d="M4 13v-1a8 8 0 0 1 16 0v5.2a2.8 2.8 0 0 1-2.8 2.8H14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 12.5h2.2v5H4.8A1.8 1.8 0 0 1 3 15.7v-1.4A1.8 1.8 0 0 1 4 12.5Zm16 0h-2.2v5H20v-5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 20h-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span><div><p class="policy-page__aside-title">Need help?</p><p class="policy-page__support-text">Questions about an order, delivery, return, or this policy?</p></div><a class="policy-page__support-button" href="mailto:muaazons@gmail.com">Contact support</a>';
    aside.appendChild(support);

    const article = document.createElement('article');
    article.className = 'policy-page__article';
    body.parentNode.insertBefore(layout, body);
    article.appendChild(body);
    const footer = document.createElement('footer');
    footer.className = 'policy-page__article-footer';
    footer.innerHTML = '<div><p class="policy-page__article-footer-title">Muaazon customer support</p><p>542, Aqsa Colony, Chikhli, Maharashtra, India 443201</p></div><a href="mailto:muaazons@gmail.com">muaazons@gmail.com</a>';
    article.appendChild(footer);
    layout.append(aside, article);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
